import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import PartnersContainer from '../../components/partners/containers/partnersContainer';
import { getPartnersDataIfNeeded } from '../../components/partners/actions/partnersActions';

const headerTags = {
    title: 'Parceiros - Impulsione a sua empresa conosco', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta: {
        description: 'Com um público altamente qualificado e diversos formatos offline e online a sua disposição, a rádio antena 1 possui os melhores projetos para o seu negócio.',
        keywords: 'negócios, business, amigos, divulgação, publicidade, comercial',
        'og:title': 'Parceiros - Impulsione a sua empresa conosco',
        'og:description': 'Com um público altamente qualificado e diversos formatos offline e online a sua disposição, a rádio antena 1 possui os melhores projetos para o seu negócio.',
    },
};

class Parceiros extends Component {
    static fetchData(store) {
        return store.dispatch(getPartnersDataIfNeeded());
    }

    render() {
        return (
            <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <PartnersContainer />
            </div>
        );
    }
}

export default Parceiros;
